export default __webpack_public_path__ + "static/logo-80e8f9d6cde024c62c35183a8c9e6361.svg";